import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY || 'AIzaSyBNKZlQzuWhUgXvjbxdycmNCmGt9M6ugEM',
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || 'digitech-prod-environment.firebaseapp.com',
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || 'digitech-prod-environment',
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || 'digitech-prod-environment.firebasestorage.app',
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID || '959833765143',
    appId:  process.env.VUE_APP_FIREBASE_APP_ID || '1:959833765143:web:2c917b326e377450273352',
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || 'G-9KVM2J3V4V'
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

export { analytics };
